if (typeof window.op !== 'undefined') {
  window.globals = window.op;
  window.translations.messages = window.op.messages;
} else if (typeof window.globals !== 'undefined') {
  window.op = window.globals;
}
